import { LoadingConstants } from '@zg-rentals/rental-manager-env';
import type { UserZuoraAccountSettingsDto } from '@zg-rentals/ts-adproducts-client';
import { AdproductsUserBillingInvoicePaymentApiHandler_getAccountPaymentSettingsForUserV2 } from '@zg-rentals/ts-adproducts-client';
import React from 'react';

export const usePaymentMethods = () => {
  const [loadingState, setLoadingState] = React.useState<string>(LoadingConstants.INITIAL);
  const [accountSettings, setAccountSettings] = React.useState<Array<UserZuoraAccountSettingsDto>>([]);

  React.useEffect(() => {
    AdproductsUserBillingInvoicePaymentApiHandler_getAccountPaymentSettingsForUserV2()
      .then((result) => {
        setLoadingState(LoadingConstants.SUCCESS);
        return setAccountSettings(result.accountSettings);
      })
      .catch(() => setLoadingState(LoadingConstants.ERROR));
  }, []);

  return {
    loadingState,
    accountSettings,
  };
};
